
/* eslint func-names: 0 */

/**
 * Store timeouts and intervals in Timers service
 * Provide a method to easily clear all timeouts (at logout)
 */


const Timers = {
    intervals: [],
    timeouts: [],
    /**
     * On logout, clear all timers started during the session to avoid unexpected events
     * after the user logs out
     */
    clear() {

        _.each(this.intervals, (item) => {

            clearInterval(item);

        });
        _.each(this.timeouts, (item) => {

            clearTimeout(item);

        });

        Timers.intervals = [];
        Timers.timeouts = [];

    },
};

export default Timers;



// WEBPACK FOOTER //
// ./scripts/common/services/util/-RFC.Timers.js